<template>
	<svg viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <rect fill="var(--initar-bg, #000)" x="0" y="0" width="200" height="200"></rect>
    <text font-family="var(--initar-font, Helvetica Neue, Helvetica, Arial, sans-serif)" font-size="80" font-weight="var(--initar-font-weight, bold)" fill="var(--initar-fg, #fff)" text-anchor="middle" dominant-baseline="middle" y="50%" x="50%">{{ initials.toUpperCase() }}</text>
	</svg>
</template>

<script>
export default {
	props: {
		initials: String
	}
}
</script>

<style>

</style>
